import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Check, Loader2 } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { api } from "../lib/api";

const QUICK = ["السعودية", "الهند", "باكستان", "بنغلاديش", "مصر", "اليمن", "السودان", "نيبال"];

const Row = ({ e, onDone, canEdit }) => {
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.setNationality(e.id, v); toast.success(`تم تحديد جنسية ${e.name}`); onDone(e.id); }
    catch (err) { toast.error(err?.response?.data?.detail || "تعذّر الحفظ"); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-wrap items-center gap-2 px-3 py-2" data-testid={`nat-row-${e.id}`}>
      <span className="min-w-0 flex-1 truncate text-sm font-semibold text-slate-800">{e.name}<span className="ms-1 text-[11px] font-normal text-slate-400" dir="ltr">{e.iqama_number || e.employee_number || ""}</span></span>
      {canEdit && (<>
        <Input list="nat-quick" value={v} onChange={(x) => setV(x.target.value)} placeholder="الجنسية" className="h-8 w-32 text-sm" data-testid={`nat-input-${e.id}`} />
        <Button size="sm" disabled={!v.trim() || busy} onClick={save} className="h-8 gap-1 bg-amber-600 hover:bg-amber-700" data-testid={`nat-save-${e.id}`}>
          {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Check className="h-3.5 w-3.5" />} حفظ
        </Button>
      </>)}
    </div>
  );
};

export const MissingNationality = ({ onFixed, canEdit }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.missingNationality().then((r) => setItems(r.items)).catch(() => {}); }, []);
  if (!items.length) return null;
  const done = (id) => { setItems((xs) => xs.filter((x) => x.id !== id)); onFixed(); };
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50/50" data-testid="missing-nationality">
      <datalist id="nat-quick">{QUICK.map((q) => <option key={q} value={q} />)}</datalist>
      <button onClick={() => setOpen(!open)} className="flex w-full items-center justify-between p-3 text-sm font-semibold text-amber-800" data-testid="missing-nationality-toggle">
        <span className="flex items-center gap-1.5"><AlertTriangle className="h-4 w-4" /> <span data-testid="missing-nationality-count">{items.length}</span> موظف بدون جنسية — لا يُحسبون في عدد المقيمين</span>
        <span className="text-xs">{open ? "إخفاء" : "عرض وتعبئة"}</span>
      </button>
      {open && <div className="max-h-80 divide-y divide-amber-100 overflow-y-auto border-t border-amber-100 bg-white">{items.map((e) => <Row key={e.id} e={e} onDone={done} canEdit={canEdit} />)}</div>}
    </div>
  );
};
